// extracted by mini-css-extract-plugin
module.exports = {"json":"App_json__30j6l"};